import React from 'react';
import './row.scss';

export interface RowItemInfoProps {
    children: any;
    aspect?: 'tile';
}

const RowItemInfo = ({children, aspect}: RowItemInfoProps) => {
    return (
        <div className={`row__info ${aspect}`}>
            {children}
        </div>
    )
}

export default RowItemInfo;
